import ImageWithFallback from '@/globalComponents/image';
import React from 'react';
import platinumBackground from '../../../public/images/planCardsBg/web/platinum.svg';
import goldBackground from '../../../public/images/planCardsBg/web/gold.svg';
import silverBackground from '../../../public/images/planCardsBg/web/silver.svg';
import valueBackground from '../../../public/images/planCardsBg/web/value.svg';
import { StaticImageData } from 'next/image';

interface PlanCardBannerProps {
  tier: string;
  isAllTrue: boolean;
}

type backgroundImageMapType = {
  [key: string]: StaticImageData;
};

const backgroundImageMap: backgroundImageMapType = {
  value: valueBackground,
  silver: silverBackground,
  gold: goldBackground,
  platinum: platinumBackground,
};

export const PlanCardBanner = (props: PlanCardBannerProps) => {
  const { tier, isAllTrue } = props;

  const renderTitle = () => (tier === 'value' ? 'BASE' : tier.toUpperCase());

  const tierNameStyles = `absolute font-bold  ${
    tier === 'platinum' ? 'text-white' : 'text-[#333333]'
  } ${
    isAllTrue
      ? 'text-xl !leading-[0.875rem] left-4 top-5 tracking-[0.125rem]'
      : ' text-2xl !leading-[0.875rem] tracking-[0.125rem] left-4 top-7 '
  }`;
  return (
    <div data-testid="amc-plan-banner" className="relative">
      <ImageWithFallback
        src={backgroundImageMap[tier.toLowerCase()]}
        alt={tier}
        width={260}
        className={`${
          isAllTrue ? 'w-[16.30rem] h-[4.6875rem]' : 'w-[22.25rem] h-[6.4375rem] '
        } rounded-tl-lg rounded-tr-lg`}
      />
      <p data-testid="amc-plan-tier" className={tierNameStyles}>
        {renderTitle()}
      </p>
    </div>
  );
};
